module.exports = __webpack_public_path__ + "static/media/rachel.a5803254.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/rachel.jpeg
// module id = 292
// module chunks = 0